<template>
    <div class="content">
        <div class="head clearfix">
            <div class="float-left head-title">学校统一入口</div>
            <img class="float-right quit-icon" src="../assets/imgs/quit-login.png" alt="" @click="quitLogin">
            <div class="float-right login-user">{{name}}</div>
            <img class="float-right user-icon" src="../assets/imgs/user-default.png" alt="">
        </div>
        <div class="">
            <img class="banner" src="../assets/imgs/banner.png" alt="">
        </div>
        <div class="body">
            <el-row>
                <el-col :xl='6' :lg="6" :md="8" :sm="12" :xs='12' v-for="(item,index) in usableStages" :key="index">
                    <div class="item" @click="toPage(item.id)">
                        <div class="item-logo">
                            <img :src="item.logo" alt="">
                        </div>
                        <div class="item-icon">
                            <img class="item-logo-icon" :src="item.logo_icon" alt="">
                            <span class="item-title">{{item.title}}</span>
                        </div>
                        <div class="item-desc">
                            {{item.desc}}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import { decryption } from '../utils'
import { getBaseInfo } from '../api'
export default {
    data(){
        return {
            name: '',           //名字
            usertype: null,     //用户类型     //用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
            xxdm: '',           //学校代码
            sex: '',            //性别
            username: '',       //登录名
            usercode: '',       //usercode
            xxtyhh: '',         //校讯通用户号
            password: '',       //密码
            token: '',          //token
            xn: '',             //学年
            xq: '',             //学期
            phone: '',          //电话
            stages: [
                {
                    logo: require('../assets/imgs/item-logo.png'),
                    logo_icon: require('../assets/imgs/item-logo-icon.png'),
                    title: '校园官网',
                    desc: '杭州市绿城亲亲育华亲亲学校官方网站',
                    type: '3,4',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 1,
                },
                {
                    logo: require('../assets/imgs/item-course.png'),
                    logo_icon: require('../assets/imgs/item-course-icon.png'),
                    title: '选课管理',
                    desc: '管理学校学生选课',
                    type: '3,4',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 2,
                },
                {
                    logo: require('../assets/imgs/item-grade.png'),
                    logo_icon: require('../assets/imgs/item-grade-icon.png'),
                    title: '成绩管理',
                    desc: '管理学生成绩',
                    type: '4',          //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 3,
                },
                {
                    logo: require('../assets/imgs/item-byod.png'),
                    logo_icon: require('../assets/imgs/item-byod-icon.png'),
                    title: 'BYOD',
                    desc: '教师对资源情况进行任务 发布和审核人分配',
                    type: '3',          //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 4,
                },
                {
                    logo: require('../assets/imgs/item-evaluation.png'),
                    logo_icon: require('../assets/imgs/item-evaluation-icon.png'),
                    title: '综合素质评价',
                    desc: '管理学生综合素质报告单',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 5,
                },
                {
                    logo: require('../assets/imgs/item-pcoa.png'),
                    logo_icon: require('../assets/imgs/item-pcoa-icon.png'),
                    title: '绿城教育OA系统',
                    desc: '绿城教育协同办公系统',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 6,
                },
                {
                    logo: require('../assets/imgs/item-education.png'),
                    logo_icon: require('../assets/imgs/item-education-icon.png'),
                    title: '绿城教育APP',
                    desc: '移动管理平台-企业管理',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 7,
                },
                {
                    logo: require('../assets/imgs/item-bb.png'),
                    logo_icon: require('../assets/imgs/item-bb-icon.png'),
                    title: 'BB平台',
                    desc: 'Blackboard Learn',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 8,
                },
                {
                    logo: require('../assets/imgs/item-face.png'),
                    logo_icon: require('../assets/imgs/item-face-icon.png'),
                    title: '人脸管理系统',
                    desc: '管理师生人脸信息',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 9,
                },
                {
                    logo: require('../assets/imgs/item-pcoa.png'),
                    logo_icon: require('../assets/imgs/item-pcoa-icon.png'),
                    title: '电子班牌管理',
                    desc: '电子班牌管理',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 11,
                },
                {
                    logo: require('../assets/imgs/bigdata.jpg'),
                    logo_icon: require('../assets/imgs/bigdata.jpg'),
                    title: '智能数据大脑',
                    desc: '教育大数据智能管理平台',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 13,
                },
                {
                    logo: require('../assets/imgs/xbf-logo.png'),
                    logo_icon: require('../assets/imgs/xbf-logo.png'),
                    title: '新步伐',
                    desc: '用量化数据明确学习薄弱点，提高学习效率！',
                    type: '2,3',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                    id: 12,
                },
                // {
                //     logo: require('../assets/imgs/item-face.png'),
                //     logo_icon: require('../assets/imgs/item-face-icon.png'),
                //     title: '数据大脑',          //这条数据是准备新加的，但是logo, logo-icon,title,desc都没描述清楚
                //     desc: '数据大脑',           //按照描述说是加在最后边
                //     type: '3,4',        //可访问的用户类型(1:系统管理员 2:学校管理员 3:普通老师 4,学生)
                //     id: 10,
                // },
            ]
        }
    },
    computed:{
        //优化v-for与v-if同时使用的问题
        usableStages: function(){
            /**
             * 这里需要根据用户类型来判断哪些链接是可以显示出来的，
             * v-for="(item,index) in stages" v-if="item.type.indexOf(usertype) != 1"
             * vue风格指南中介绍永远不要把 v-if 和 v-for 同时用在同一个元素上。
             * 按照vue风格指南中的介绍改成计算属性，使用js filter方法解决
             */
            let _self = this;
            return this.stages.filter(function(stage){
                return stage.type.indexOf(_self.usertype) !=-1
            })
        }
    },
    methods:{
        //初始化数据，隐私数据加解密操作
        init(){
            //取到解密后的数据
            this.name = decryption(localStorage.getItem('name'))
            this.usertype = decryption(localStorage.getItem('type'))
            this.xxdm = decryption(localStorage.getItem('xxdm'))
            this.sex = decryption(localStorage.getItem('sex'))
            this.username = decryption(localStorage.getItem('username'))
            this.password = decryption(localStorage.getItem('password'))
            this.phone = decryption(localStorage.getItem('phone'))
            this.xxtyhh = decryption(localStorage.getItem('xxtyhh'))
            this.token = localStorage.getItem('token')
            this.getBaseInfo(this.xxdm);
        },
        //获取当前学年学期
        getBaseInfo(xxdm){
            let data = {
                xxdm: xxdm
            }
            getBaseInfo(data).then((res)=>{
                if(res.status == 200){
                    this.xn = res.data.xn;
                    this.xq = res.data.xq;
                }
            })
        },
        //退出登录
        quitLogin(){
            if(localStorage.getItem('token')){
                localStorage.removeItem('token')
            }
            this.$router.push({path:'/'})
            console.log('quitlogin')
        },
        //跳转页面
        toPage(id){
            let params = {};
            let api = ''
            switch(id){
                case 1:
                    api = 'http://lcqqnew.91sst.com.cn/Account/LoginJumpFun?'
                    params = {
                        UserId: this.xxtyhh
                    }
                    open(api,params)
                    break;
                case 2:
                    api = 'http://lcyhqqxx.91sst.com/student/#/login?'
                    params = {
                        username: this.username,
                        password: this.password
                    }
                    //根据不同用户类型做不同的处理
                    if(this.usertype == 3){
                        api = 'http://lcyhqqxx.91sst.com/admin/#/authredirect?'
                        params.to = 'xkxt'
                    }
                    console.log('aaaaaaaaaaaaaaaaa');
                    open(api,params)
                    break;
                case 3:
                    api = 'http://60.191.57.105:8085/szxy/edu_jwcj_cjlr/cjlr_listOne.do?'
                    params = {
                        username: this.xxtyhh,
                        sfweb: 1,
                        xqparam: this.xq,
                        xnparam: this.xn
                    }
                    open(api,params)
                    break;
                case 4:
                    /**
                     * window.open("http://60.191.57.105:8085/szxy/sys_login/login_tyLogin.do?yhm=" + encodeURIComponent(this.username) + "&yhlx=" + this.type + "&gnmk=" + t, "_blank")
                     */
                    api = 'http://60.191.57.105:8085/szxy/sys_login/login_tyLogin.do?'
                    params = {
                        yhm: this.username,
                        yhlx: this.usertype,
                        gnmk: 'byod'
                    }
                    open(api,params)
                    break;
                case 5:
                    api = 'http://lcyhqqxx.91sst.com//admin/#/authredirect?'
                    params = {
                        username: this.username,
                        password: this.password,
                        to: 'xfpj'
                    }
                    open(api,params)
                    break;
                case 6:
                    window.open("http://115.236.70.246:81/wui/index.html#/?logintype=1&_key=neu2r1");
                    break;
                case 7:
                    window.open("http://115.236.70.246:8999/#/ ");
                    break;
                case 8:
                    window.open("https://bb.lcyhqqxx.com/")
                    break;
                case 9:
                    window.open("http://60.191.75.90:8080/scProj/admin/logout");
                    break;
                case 10:
                    window.open('http://120.55.69.230:8027/index')
                    break;
                case 11:
                    // api = 'http://localhost:8092/login?'
                    api = 'http://newoa.91118.com/login?'
                    params = {
                        username: this.username,
                        password: this.password,
                        to: 'xfpj'
                    }
                    open(api,params)
                    break;
                case 12:
                    window.open('http://www.new-steps.com/v2/')
                    break;
                case 13:
                    // api = 'http://localhost:8092/login?'
                    api = 'http://120.55.69.230:8438?'
                    params = {
                        username: this.xxdm + this.username,
                        password: this.password
                    }
                    open(api,params)
                    break;
                default:
                    break;
            }
            //拼接url和params参数
            function open(base,params){
                console.log('bbbbbbbbbbbbbbbbbb');
                let url = ''
                for(let i in params){
                    console.log(i)
                    if(url){
                        url = url + '&' + i + '=' + params[i]
                    }else{
                        url = i + '=' + params[i]
                    }
                    
                }
                // alert(base+url)
                window.open(base+url)
            }
        }
    },
    mounted(){
        this.init()
    }
}
</script>
<style scoped>
.content{
    background: #e7eff4;
    width: 100%;
    min-height: 100vh;
}
.head{
    height: 60px;
    background-color: #0f4c1d;
}
.float-left{
    float: left;
}
.float-right{
    float: right;
}
.head-title{
    line-height: 60px;
    color: #fff;
    color: #fff;
    font-size: 18px;
    padding-left: 2%;
}
.user-icon{
    width: 28px;
    height: 28px;
    margin: 16px 10px 0 0;
    border-radius: 50%;
}
.login-user{
    color: #fff;
    font-size: 14px;
    line-height: 60px;
    margin-right: 10px;
}
.quit-icon{
    width: 17px;
    height: 17px;
    margin: 21px 40px 0 0;
}
.clearfix:after{
    content: ".";
    clear: both;
    height: 0;
    overflow: hidden;
    display: block;
}
.banner{
    width: 100%;
}
.body{
    width: 60%;
    margin: 0 auto;
}
.item-logo{
    width: 164px;
    height: 111px;
    border-radius: 20px;
    overflow: hidden;
}
.item-logo img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.item-logo-icon{
    width: 16px;
    height: 16px;
}
.item-title{
    text-align: center;
    font-size: 16px;
    color: #333;
    font-weight: 700;
    margin-left: 6px;
}
.item-desc{
    font-size: 12px;
    color: #333;
    padding: 10px;
}
.item{
    width: 165px;
    height: 220px;
    background: #fff;
    border-radius: 14px;
    margin: 50px auto;
    cursor: pointer;
}
.item-icon{
    margin-top: 10px;
    padding-left: 10px;
}
</style>